(function(Manogi, $, undefined) {
    
    //Public
   
    Manogi.redeemCouponInCart = function() {
        var $input = $('input[name=coupon_code]');
        var coupon_code = $('input[name=coupon_code]').val();
        if($.trim(coupon_code)){
            $.oc.stripeLoadIndicator.show();
            
            $input.request('cartHandler::onRedeemCouponInCart', {
                data: {
                    coupon_code : coupon_code
                },
                success: function(response) {
                    if(!response['added']){
                        $.oc.stripeLoadIndicator.hide();
                        $('.js-coupon-message').text(response['message']);
                    }
                    else {
                        window.location.reload();
                    }
                    
                }
            });
        }
        
    };

    
    


}( window.Manogi = window.Manogi || {}, jQuery ));